export default __webpack_public_path__ + "static/media/thsarabunnew_bolditalic-webfont.ac109a53.woff";